import { SvgIcon, SvgIconProps } from '@mui/material';

import { VFC } from 'react';

export const FacebookIcon: VFC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 28 28" {...props}>
    <path
      fill="#000"
      d="M17.2757 7.76275H19.0303V4.79476C18.1808 4.70641 17.3271 4.6628 16.473 4.66409C13.9343 4.66409 12.1983 6.21342 12.1983 9.05075V11.4961H9.33301V14.8187H12.1983V23.3307H15.633V14.8187H18.489L18.9183 11.4961H15.633V9.37742C15.633 8.39742 15.8943 7.76275 17.2757 7.76275Z"
    />
  </SvgIcon>
);
